// Enhanced WhatsApp Button with Multiple Animation Styles
(function() {
  'use strict';
  
  function initWhatsAppButtons() {
    const buttons = document.querySelectorAll('.whatsapp-button');
    
    buttons.forEach(function(button) {
      // Remove existing listeners
      button.removeEventListener('click', handleWhatsAppClick);
      button.removeEventListener('mousemove', handleMagneticHover);
      button.removeEventListener('mouseleave', handleMagneticLeave);
      button.removeEventListener('mouseenter', handleButtonEnter);
      
      // Add new listeners
      button.addEventListener('click', handleWhatsAppClick);
      button.addEventListener('mousemove', handleMagneticHover);
      button.addEventListener('mouseleave', handleMagneticLeave);
      button.addEventListener('mouseenter', handleButtonEnter);
      
      // Initialize button based on animation style
      initButtonStyle(button);
    });
  }
  
  function initButtonStyle(button) {
    const animationStyle = button.getAttribute('data-animation-style') || 'cro-optimized';
    
    // Add attention animation for CRO optimized style
    if (animationStyle === 'cro-optimized') {
      setTimeout(() => {
        button.classList.add('attention');
        setTimeout(() => {
          button.classList.remove('attention');
        }, 3000);
      }, 1000);
    }
  }
  
  function handleMagneticHover(e) {
    const button = e.currentTarget;
    const animationStyle = button.getAttribute('data-animation-style');
    
    // Only apply magnetic effect to magnetic-hover style
    if (animationStyle !== 'magnetic-hover') return;
    
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    
    const distance = Math.sqrt(x * x + y * y);
    const maxDistance = 50;
    
    if (distance < maxDistance) {
      const moveX = (x / maxDistance) * 10;
      const moveY = (y / maxDistance) * 10;
      
      button.style.transform = `translateX(calc(-50% + ${moveX}px)) translateY(calc(-2px + ${moveY}px)) scale(1.05)`;
    }
  }
  
  function handleMagneticLeave(e) {
    const button = e.currentTarget;
    const animationStyle = button.getAttribute('data-animation-style');
    
    if (animationStyle === 'magnetic-hover') {
      button.style.transform = 'translateX(-50%) translateY(-2px) scale(1.05)';
    }
  }
  
  function handleButtonEnter(e) {
    const button = e.currentTarget;
    const animationStyle = button.getAttribute('data-animation-style');
    
    // Add special effects based on animation style
    if (animationStyle === 'glassmorphism') {
      button.style.backdropFilter = 'blur(25px)';
    }
  }
  
  function handleWhatsAppClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.currentTarget;
    const productName = button.getAttribute('data-product-name') || 'this product';
    const productUrl = button.getAttribute('data-product-url') || window.location.href;
    const whatsappNumber = button.getAttribute('data-whatsapp-number');
    
    if (!whatsappNumber || whatsappNumber.trim() === '') {
      console.error('WhatsApp number not configured');
      alert('WhatsApp number is not configured. Please contact the store administrator.');
      return;
    }
    
    const cleanNumber = whatsappNumber.replace(/[^\d+]/g, '');
    const message = `Hi, I'm interested in ${productName} - ${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
    
    // Add loading state
    button.classList.add('loading');
    button.disabled = true;
    
    // Add ripple effect
    createRippleEffect(button, e);
    
    setTimeout(function() {
      window.open(whatsappUrl, '_blank');
      
      setTimeout(function() {
        button.classList.remove('loading');
        button.disabled = false;
      }, 2000);
    }, 500);
  }
  
  function createRippleEffect(button, event) {
    const ripple = button.querySelector('.whatsapp-button__ripple');
    if (!ripple) return;
    
    const rect = button.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    ripple.style.width = '0px';
    ripple.style.height = '0px';
    
    // Trigger ripple animation
    setTimeout(() => {
      ripple.style.width = '200px';
      ripple.style.height = '200px';
    }, 10);
  }
  
  // Initialize particles animation
  function initParticles() {
    const particleButtons = document.querySelectorAll('.whatsapp-button--particles');
    
    particleButtons.forEach(button => {
      const particles = button.querySelectorAll('.whatsapp-button__particles span');
      particles.forEach((particle, index) => {
        particle.style.animationDelay = `${index * 0.5}s`;
      });
    });
  }
  
  // Initialize all effects
  function initializeAll() {
    initWhatsAppButtons();
    initParticles();
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  
  // Re-initialize on section load/reorder
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:reorder', initializeAll);
  
  // Re-initialize on dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasWhatsAppButtons = addedNodes.some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('whatsapp-button') || 
            node.querySelector?.('.whatsapp-button')
          )
        );
        
        if (hasWhatsAppButtons) {
          setTimeout(initializeAll, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();